module.exports = __webpack_public_path__ + "static/img/three.c305d22a.svg";